export class ProcessedDataResponse<S> {
    public code: number;
    public data?: S;
    public error?: string;
}